import React, {Component} from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import './AuthenticateItems.scss'
import ActionLink from "../../link/ActionLink";
import auth from '../../user/services/Auth';
import { getLanguage } from '../../../store/rootReducer';
import ClickableDiv from "../../button/ClickableDiv";

class AuthenticateItems extends Component {

  signIn = () => {
    auth.login(this.props.lang)
  };

  createAccount = () => {
    this.props.history.push('/register');
  };

  render() {
      return (
        <div className="hrb-navbar-auth">
            <ClickableDiv onClick={this.signIn}>
                <ActionLink text="navbar.sign_in"/>
            </ClickableDiv>
            <ClickableDiv className="hrb-navbar-create" onClick={this.createAccount}>
                <ActionLink text="navbar.create_account"/>
            </ClickableDiv>
        </div>
    )
  }
}

AuthenticateItems.propTypes = {
    lang: PropTypes.string.isRequired
};
  
const mapStateToProps = (state) => {
  return {
    lang: getLanguage(state)
  }
};

export default connect(mapStateToProps)(AuthenticateItems);